import { makeStyles } from '@material-ui/core';
import { Grid, Typography } from '@mui/material';
import React, { useEffect } from 'react';
import Autocomplete2 from 'components/Autocomplete2';
import { useSelector } from 'react-redux';

const useStyles = makeStyles((theme) => ({
  reportContainer: {
    display: 'flex',
  },
  reportSelection: {
    flex: 0.3,
  },
  reportFilter: {
    flex: 0.7,
  },
  report: {
    paddingBottom: '4px',
  },
}));


const CADDataByMonth = (props) => {
  const classes = useStyles();
  const { reportForm, handleReportFormChange, ReportID } = props;
  const formValue = reportForm[ReportID] || {};
  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: currentYear - 2000 + 1 }, (_, i) => {
    const y = 2000 + i;
    return { Code: y.toString() };
  }).reverse();
  const year = { Code: currentYear.toString() };  
  const agencies =  useSelector((state) => state.dictionary?.Agencies ?? []);
  const agenciesList = agencies.map(item => ({
    Code: item.AgencyID
  }));
  const agency = { Code : useSelector((state) => state.user.userData.user.AgencyID).toString() };
  useEffect(() => {
    if (!formValue.agency) {
      handleReportFormChange(ReportID, "agency", agency);
    }
  }, []);
  return (
    <div className={classes.report}>
      <Grid container justifyContent="space-between">
        <Grid item xs={6}>
          <Typography variant="subtitle1" className="py-2">
            {props.title}
          </Typography>
        </Grid>
      </Grid>
      <Grid container justify="left" alignItems="center" spacing={1}>
        <Grid item xl={2} md={2} sm={12} xs={12} className={classes.marginNormal}>
          <Autocomplete2
            options={years} 
            className={classes.year}
            onChange={(ev, newVal) => handleReportFormChange(ReportID, 'year', newVal)}
            value={formValue.year || year}
            label="Year"
            compact="true"
          />
        </Grid>
        <Grid item xl={2} md={2} sm={12} xs={12} className={classes.marginNormal}>
          <Autocomplete2
            options={agenciesList} 
            className={classes.agency}
            onChange={(ev, newVal) => handleReportFormChange(ReportID, 'agency', newVal)}
            value={formValue.agency ?? null}
            label="Agency"
            compact="true"
            error={!formValue.agency}
          />
        </Grid>
      </Grid>
    </div>
  );
};

export default CADDataByMonth;
